package com.devi3east.bashbuddy.common.service

data class AppConfigUiState(
    val currentMobileVersion: Int? = null,
    val minimumMobileVersion: Int? = null,
    val leaderboardPromotionEnabled: Boolean = false,
    val isLoading: Boolean = true
)